import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { dollars, formatCurrency } from "@/domains/library"
import { TokenIcon } from "@/domains/tokens/components/token-icon"

interface ZapApprovingProps {
  store: ZapStore
}

export const ZapApproving = observer(({ store }: ZapApprovingProps) => {
  if (!store.estimate) return null
  if (!store.pool) return null
  if (!store.zapToken) return null

  return (
    <div className="text-t100 border-p400-light bg-p400 flex h-40 items-center justify-center rounded-lg border px-4 py-3 text-center">
      <div>
        <p className="text-t200 mb-1">Approving access for</p>
        <div className="mb-2 flex items-center justify-center gap-2 text-lg md:text-4xl">
          {formatCurrency(store.displayInputAmount)}
          <TokenIcon token={store.zapToken} size={32} />
          {store.zapToken?.symbol}
        </div>

        <div className="text-t200 text-sm">
          <p>
            To receive {dollars(store.estimate.context.outputAmountUsd)} {store.pool?.displayName}
          </p>
          <p className="text-t200 text-sm">
            @ {store.estimate.context.slippageTolerancePercentage.toFixed(2)}% slippage
          </p>
        </div>
      </div>
    </div>
  )
})
